// Copyright (c) 2018 Deere & Company

import ExcelLayout, {getDefaultState as getExcelLayoutDefaultState} from '@deere/cps-it.warranty-model-factory/lib/excel-layout';
import ExcelLayoutColumn from '@deere/cps-it.warranty-model-factory/lib/excel-layout-column';
import t from 'tcomb';

const ExcelLayoutModal = t.struct({
    availableColumns: t.list(ExcelLayoutColumn, 'ExcelLayoutColumn'),
    excelLayout: ExcelLayout,
    isModalOpen: t.Boolean,
    isNameValid: t.Boolean,
    isNewLayout: t.Boolean
}, {
    name: 'ExcelLayoutModal',
    strict: true
});

export const getDefaultState = () => new ExcelLayoutModal({
    availableColumns: [],
    excelLayout: getExcelLayoutDefaultState(),
    isModalOpen: false,
    isNameValid: true,
    isNewLayout: false
});

export default ExcelLayoutModal;



// WEBPACK FOOTER //
// ./src/shared/state/excel-layout-modal.js